<template>
  <div class="exercise">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li><router-link to="/luyen-tap">Luyện tập</router-link></li>
          <li v-if="bookLocalSave">
            <router-link :to="{name:'exercise',query: {classes: bookLocalSave.classId}}">{{ bookLocalSave.className }}</router-link>
          </li>
          <li v-if="bookLocalSave">{{bookLocalSave.subject.name}}</li>
        </ul>
      </div>
    </div>
    <div class="exercise-subject">
      <div class="container-hts">
        <div class="exercise-subject__wrap display-flex justify-content-between">
          <div class="exercise-subject__sidebar">
            <ul class="margin-0 p-0">
              <li
                v-for="(item,index) of practiceType"
                @click="getBookOrPracticeList(item)"
                :class="{ active: practiceActive && item.practiceTypeId === practiceActive.practiceTypeId }"
                :key="index"
              >
                <a href="javascript:;">{{item.name}}</a>
              </li>
            </ul>
          </div>
          <ExerciseSubjectNumber v-if="isIndexList" />
          <ExerciseSubjectLife v-if="!isIndexList" />
          <!-- <ExerciseSubjectNumber v-if="id===4"/> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import ExerciseSubjectNumber from "../_components/ExerciseSubject/ExerciseSubjectNumber";
import ExerciseSubjectLife from "../_components/ExerciseSubject/ExerciseSubjectLife";
import { APP_CONFIG } from "@/utils/constants";
import { LOCAL_SAVE_BOOK_ACTIVE, LOCAL_SAVE_PRACTICE_LIST, LOCAL_SAVE_CAT } from "./../_store/constants";
import { getPracticeType } from './../_api/'
// import { LOCAL_SAVE_ID } from "../_store/constants";
// import { LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE } from "./../_store/constants";
// import { LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE1 } from "./../_store/constants";
export default {
  name: "ExerciseSubject",
  components: {
    ExerciseSubjectNumber,
    ExerciseSubjectLife
  },
  data() {
    return {
      isIndexList: true,
      nameSubject: "",
      classIdstorge: 0,
      id: 1,
      bookLocalSave: null,
      practiveLocalSave: null,
      practiceType: [],
      // practiceActive: 0,
    };
  },
  computed: {
    ...mapGetters({
      getExerciseDetailNumber: STORE_KEY + "/getExerciseDetailNumber",
      // getPracticeType: STORE_KEY + "/getPracticeType",
      getLisstPracticeTypeBook: STORE_KEY + "/getLisstPracticeTypeBook",
      getActive: STORE_KEY + "/getActive",
      practiceActive: STORE_KEY + "/practiceActive"
    }),
    classId() {
      return this.$route.params.classId;
    },
    subjectId() {
      return this.$route.params.subjectId;
    }
  },
  created() {
    this.getGetPracticeType();
  },
  mounted() {
    this.getDataLocalSaved();
    localStorage.removeItem(LOCAL_SAVE_CAT);
    // if (localStorage.getItem(LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE) == null) {
    //   this.id = localStorage.getItem(LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE1);
    // }

    // if (localStorage.getItem(LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE) != null) {
    //   this.id = localStorage.getItem(LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE);
    // }
    // this.nameSubject = localStorage.getItem(LOCAL_SAVE_SUBJECT_NAME);
    // this.classIdstorge = localStorage.getItem(LOCAL_SAVE_ID);
    //  localStorage.removeItem(LOCAL_SAVE_SUBJECT_NAME);
  },
  watch: {
    // id: "handleChangIndex",
    // getPracticeType(newVal, oldVal) {
    //   // console.log("745737585484848",newVal)
    //   var id = localStorage.getItem(LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE);
    //   if (id != null) {
    //     var a = this.getPracticeType.find(
    //       element => element.practiceTypeId == id
    //     );
    //     this.isIndexList = a.isIndexList;
    //   }
    // }
  },
  methods: {
    ...mapActions(STORE_KEY, ["actionLuggageNumber", "actionGetListPracticeTypeBook", "actionSetPracticeCurr"]),

    getDataLocalSaved() {
      let dataLocal = localStorage.getItem(LOCAL_SAVE_BOOK_ACTIVE);
      if(dataLocal && dataLocal !== null && dataLocal !== undefined) {
        this.bookLocalSave = JSON.parse(dataLocal);
      }
    },

    getGetPracticeType() {
      let self = this;
      getPracticeType(self.classId).then(res => {
        // console.log('Data practice: ', res);
        if(res && res.data && !res.errors) {
          self.practiceType = res.data;
          let dataPraSave = localStorage.getItem(LOCAL_SAVE_PRACTICE_LIST);
          if(dataPraSave && dataPraSave !== null && dataPraSave !== undefined) {
            self.practiveLocalSave = JSON.parse(dataPraSave);
            self.getBookOrPracticeList(self.practiveLocalSave)
          } else {
            res.data.length > 0 && self.getBookOrPracticeList(res.data[0])
          }
        }
      })
      // this.actionGetPracticeType(this.classId);
    },

    getBookOrPracticeList(val) {
      let self = this;
      self.isIndexList = val.isIndexList;
      // self.practiceActive = val.practiceTypeId;
      // console.log('before set: ', val);
      if(val.isIndexList) {
        self.actionLuggageNumber({classId: self.classId, subjectId: self.subjectId})
      } else {
        this.actionGetListPracticeTypeBook({ classId: self.classId, subjectId: self.subjectId, practiceTypeId: val.practiceTypeId });
      }
      self.actionSetPracticeCurr(val);
      // console.log('get detail: ', val)
    },

    Dispalyindex(id, isIndexList) {
      this.id = id;
      this.isIndexList = isIndexList;
      // localStorage.setItem(LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE, id);
    },
    handleChangIndex() {
      if (this.isIndexList) {
        this.actionLuggageNumber({
          classId: this.classId,
          subjectId: this.subjectId
        });
      }

      if (!this.isIndexList) {
        let data = {};
        data["classId"] = this.classIdstorge;
        data["SubjectId"] = this.subjectId;
        data["PracticetypeId"] = this.id;
        this.actionGetListPracticeTypeBook(data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "./../../../assets/scss/variables";
  @import "./../../../assets/scss/mixins";
  @import "./../../../assets/scss/general";

  .exercise-subject {
    padding: 50px 0;

    ul {
      li {
        @extend .list-style-none;
      }
    }

    &__sidebar {
      width: 27%;
      margin-right: 6%;

      ul {
        li {
          min-height: 36px;
          padding: 7px 18px;
          @extend .border-rd-8;
          margin-bottom: 2px;
          line-height: 1.2;

          a {
            @extend .secondary-color-txt;
          }

          &.active,
          &:hover {
            background: $btn_hover_color;
            a {
              @extend .primary-color;
              @extend .font-sanpro-semibold;
            }
          }
        }
      }
    }

    &__list {
      width: 67%;

      .item {
        padding: 15px 24px;
        background: $color_bg_gray_light;

        &__head {
          border-bottom: 1px solid $secondary_text_color;
          padding-bottom: 13px;
        }

        &__body {
          padding: 10px 0;

          ul {
            li {
              width: 49%;
              display: inline-block;
              margin-bottom: 4px;

              &:nth-child(odd) {
                margin-right: 2%;
              }

              a {
                @extend .secondary-color-txt;
              }
            }
          }
        }

        &:not(:last-child) {
          margin-bottom: 18px;
        }
      }
    }

    @media screen and (max-width: 991px) {
      &__list {
        .item {
          &__body {
            ul {
              li {
                width: 100%;

                &:nth-child(odd) {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }

    @media screen and (max-width: 767px) {
      &__wrap {
        display: block;
      }

      &__sidebar,
      &__list {
        width: 100%;
      }

      &__sidebar {
        margin: 0 0 20px 0;
      }
    }
  }
</style>